import type { IProductBundleOption } from "@rogue/universal"
import type { BundleUIOption } from "../RuleTypes"
import type { Product, IRogue, BuyRequest } from "@/js/services/RogueTypes"

export function getOptionsForLatAndLowRow(rogue: IRogue, rack: Product, bundleOption: IProductBundleOption, options: BundleUIOption[], bundleBuyRequest: BuyRequest) {
  const rackSize = rack.attributes.rack_size?.toString().toLowerCase()
  const is4Post = Boolean(rackSize && rackSize.indexOf('4') !== -1)
  const is6Post = Boolean(rackSize && rackSize.indexOf('6') !== -1)
  const title = bundleOption.title.toLowerCase().replace(':', '').trim()  
  const isOptFor6Post = ['middle crossmember', 'front crossmember'].includes(title)
  const isOptFor4Post = ['add half rack feet'].includes(title)
  const isSlimRack = rack.attributes?.rack_depth === '14"'
  let retval = options

  // Filter out the "None" option on front and middle crossmembers
  if (is6Post && isOptFor6Post) {
    retval = retval.filter(opt => !opt.label.includes('None'))

    // Filter out top crossmembers from the PU bar options
    if (title.includes('front crossmember')){
      retval = retval.filter(opt => !opt.label.includes('Top Crossmember'))
    }
  } 

  return retval.filter(opt => {
    if (!opt.value) {
      return true
    }
    
    const product = rogue.getProductById(opt.value)
    const depth = rack.attributes.rack_depth
    const rackBeamColor = rack.attributes.beam_color
   
    const isSatinBlackTopCrossmember = product.name.includes('Top Crossmember') && product.name.includes('Satin Black')
    const isSatinBlackRearCrossmember = product.name.includes('Beam w/ Gusset') && product.name.includes('Satin Black') && !product.name.includes('Crown')

    const rackSupportsTexturedBlackNameplate = rack.name?.includes('RML-490') || rack.name?.includes('RML-690') || rack.name?.includes('FML-6')
    const texturedBlackRackColorSelected = rack.name.includes('Textured Black')
    const isNameplateProduct = product.name.includes('Nameplate')
    const texturedBlackProductSelected = product.name.includes('Textured Black')

    // Hide 6 post options on the half rack
    if (is4Post && isOptFor6Post && !isSlimRack) {
      return false
    }

    // Hide the half rack options on 6 post racks
    if (is6Post && isOptFor4Post) {
      return false
    }

    // Hide duplicate black nameplate options
    if (rackSupportsTexturedBlackNameplate && isNameplateProduct && (texturedBlackRackColorSelected !== texturedBlackProductSelected)) {
      return false
    }

    // Show the satin black rear crossmember only with MG colors
    if (isSatinBlackRearCrossmember && !rackBeamColor?.toString().includes('Textured')) {
      return true
    }

    // Always show a satin black top crossmember
    if (isSatinBlackTopCrossmember) {
      return true
    }

    // For nameplates / beams, restrict the rear crossmember options to only the same color as the rack
    if (rackBeamColor && !product.name.includes('Nameplate') && product.attributes.beam_color && product.attributes.beam_color !== rackBeamColor) {
      return false
    }

    // Hide mismatched depth options
    if (depth && product.attributes.rack_depth && product.attributes.rack_depth !== depth) {
      return false
    }

    return true
  })
}